"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileSearchSolid: function() {
        return FileSearchSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileSearchSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.5 14C10.6716 14 10 14.6716 10 15.5C10 16.3284 10.6716 17 11.5 17C12.3284 17 13 16.3284 13 15.5C13 14.6716 12.3284 14 11.5 14Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 1C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V8C21 7.73478 20.8946 7.48043 20.7071 7.29289L14.7071 1.29289C14.5196 1.10536 14.2652 1 14 1H6ZM18.5 8L14 3.5V7C14 7.55228 14.4477 8 15 8H18.5ZM8 15.5C8 13.567 9.567 12 11.5 12C13.433 12 15 13.567 15 15.5C15 16.1028 14.8476 16.6699 14.5793 17.1651L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L13.1651 18.5793C12.6699 18.8476 12.1028 19 11.5 19C9.567 19 8 17.433 8 15.5Z",
            fill: "currentColor"
        })
    ]
}), "FileSearchSolid");
const _default = FileSearchSolid;
